/**
 * Public URL for R2 / CDN object keys (marketing / static).
 * Local dev always uses staging R2 (VITE_STORAGE_STAGING_PUBLIC_BASE_URL).
 * Deployed builds use VITE_STORAGE_PUBLIC_BASE_URL (mirrors backend STORAGE_PUBLIC_BASE_URL).
 */
import { isLocalDevHostname, normalizeVidhyantraDomain } from '@/utils/cookie-domain.util'

/** Staging R2 public CDN — used when running on localhost / vidhyantra.local. */
const DEFAULT_STAGING_STORAGE_PUBLIC_BASE = 'https://vidhyantra-bucket.vidhyantra.com'

export function getStoragePublicBaseUrl(): string {
  if (typeof window !== 'undefined' && isLocalDevHostname()) {
    const stagingRaw = import.meta.env.VITE_STORAGE_STAGING_PUBLIC_BASE_URL as string | undefined
    const staging = normalizeVidhyantraDomain(stagingRaw)?.replace(/\/$/, '')
    return staging || DEFAULT_STAGING_STORAGE_PUBLIC_BASE
  }

  const raw = import.meta.env.VITE_STORAGE_PUBLIC_BASE_URL as string | undefined
  return normalizeVidhyantraDomain(raw)?.replace(/\/$/, '') ?? ''
}

/** R2 object keys (paths inside the bucket, not full URLs). */
export const STORAGE_OBJECT_KEYS = {
  branding: {
    favicon: 'platform/vidyantra_logos/fav_icon.png',
    lightLogo: 'platform/vidyantra_logos/Light_mode_logo.png',
    darkLogo: 'platform/vidyantra_logos/Dark_Mode_logo.png',
  },
  homePage: {
    whyChooseVid: 'Home Page/why choos VID.png',
    whyChooseGif: 'Home Page/Why choose.gif',
    secureGif: 'Home Page/Secure.gif',
  },
} as const

export function getPublicFileUrl(key: string): string {
  const base = getStoragePublicBaseUrl()
  const relative = key.replace(/^\/+/, '')
  const path = relative
    .split('/')
    .map((seg) => encodeURIComponent(seg))
    .join('/')
  return base ? `${base}/${path}` : `/${path}`
}
